import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FreeSearch, Lookup } from 'src/app/app.types';

@Component({
    selector: 'free-search',
    templateUrl: './free-search.component.html',
    styleUrls: ['./free-search.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FreeSearchComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class FreeSearchComponent implements ControlValueAccessor {
  @Input() searchOptions: Lookup[] = [];
  currentSearch: FreeSearch = {property: null, searchTerm: null};
  isDropdownOpen = false;
  
  private onChange!: (value: FreeSearch) => void;
  private onTouched!: () => void;


  writeValue(obj: any): void {
    this.currentSearch = obj;
  }

  registerOnChange(fn: (value: FreeSearch) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    
  }

  search(searchTerm: string){
    this.onChange({...this.currentSearch, searchTerm});
  }

  selectOption(option: Lookup) {
    this.currentSearch = {...this.currentSearch, property: option};
    this.isDropdownOpen = false;
    this.onChange(this.currentSearch);
  }
}
